import {
  CORE_LOAD_ALL_ZONE_REQUEST,
  CORE_LOAD_ALL_ZONE_SUCCESS,
  CORE_LOAD_ALL_ZONE_FAILURE
} from '../types'
const requestState = 'request'
  , initialState = []
// , initialStateObj = {}
export default {
  allzone: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_ZONE_REQUEST:
        return requestState
      case CORE_LOAD_ALL_ZONE_SUCCESS:
        let result = []
        if (result && Array.isArray(action.payload)) {
          result = action.payload
        }
        return result
      case CORE_LOAD_ALL_ZONE_FAILURE:
        return initialState
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerZone.js